module.exports = __webpack_public_path__ + "img/icon_sm_kcpd.5798a344.png";